// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: eYYlTSbDuk
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import BtnText from "../../BtnText"; // plasmic-import: R3LXVa6EIz/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicReturnModal.module.css"; // plasmic-import: eYYlTSbDuk/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: LYoK9OD3Rv/icon

createPlasmicElementProxy;

export const PlasmicReturnModal__VariantProps = new Array();

export const PlasmicReturnModal__ArgProps = new Array();

const $$ = {};

function PlasmicReturnModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__a4LXm)}>
        <div className={classNames(projectcss.all, sty.freeBox__x03KP)}>
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Return"}
          </div>
          <Icon12Icon
            data-plasmic-name={"btnClose"}
            data-plasmic-override={overrides.btnClose}
            className={classNames(projectcss.all, sty.btnClose)}
            role={"img"}
          />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__iwwag)}>
          <div
            data-plasmic-name={"error"}
            data-plasmic-override={overrides.error}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.error
            )}
          >
            {"Would you like to return to the last activity?"}
          </div>
          <div
            data-plasmic-name={"txtTitle"}
            data-plasmic-override={overrides.txtTitle}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.txtTitle
            )}
          >
            {"Enter some text"}
          </div>
          <Stack__
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__ooDcu)}
          >
            <BtnText
              data-plasmic-name={"btnYes"}
              data-plasmic-override={overrides.btnYes}
              blue={true}
              className={classNames("__wab_instance", sty.btnYes)}
            >
              {"Yes"}
            </BtnText>
            <BtnText
              data-plasmic-name={"btnNo"}
              data-plasmic-override={overrides.btnNo}
              className={classNames("__wab_instance", sty.btnNo)}
              green={true}
              red={true}
            >
              {"No"}
            </BtnText>
          </Stack__>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "text", "btnClose", "error", "txtTitle", "btnYes", "btnNo"],
  text: ["text"],
  btnClose: ["btnClose"],
  error: ["error"],
  txtTitle: ["txtTitle"],
  btnYes: ["btnYes"],
  btnNo: ["btnNo"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicReturnModal__ArgProps,
          internalVariantPropNames: PlasmicReturnModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicReturnModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicReturnModal";
  } else {
    func.displayName = `PlasmicReturnModal.${nodeName}`;
  }
  return func;
}

export const PlasmicReturnModal = Object.assign(
  // Top-level PlasmicReturnModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    btnClose: makeNodeComponent("btnClose"),
    error: makeNodeComponent("error"),
    txtTitle: makeNodeComponent("txtTitle"),
    btnYes: makeNodeComponent("btnYes"),
    btnNo: makeNodeComponent("btnNo"),
    // Metadata about props expected for PlasmicReturnModal
    internalVariantProps: PlasmicReturnModal__VariantProps,
    internalArgProps: PlasmicReturnModal__ArgProps
  }
);

export default PlasmicReturnModal;
/* prettier-ignore-end */
